import React, { useState } from 'react';
import classnames from 'classnames';

import style from './Text.module.scss';

import { FieldTitle, FieldTitleModificator, FieldTitleTheme } from '../FieldTitle';
import { Icon, IconType } from '@components/Icon';

export interface TextProps {
    text: React.ReactNode | React.ReactNode[];
    prefix?: React.ReactNode;
    boldTitle?: boolean;
    title?: string;
    additionalClass?: string;
    withoutMinHeight?: boolean;
    isValid?: boolean;
    isHidingText?: boolean;
    modifiers?: TextModifiers[];
}

interface Props extends TextProps {}

export enum TextModifiers {
    // @ts-ignore
    SmallText = style.smallText,
    // @ts-ignore
    GreyText = style.greyText,
    // @ts-ignore
    PreLineText = style.preLineText,
}

export function Text({
    text,
    title,
    isHidingText,
    additionalClass,
    withoutMinHeight,
    boldTitle,
    prefix,
    isValid,
    modifiers = [],
}: Props) {
    const [isTextHide, setIsHide] = useState<boolean>(isHidingText ?? false);
    return (
        <div className={classnames(style.root, additionalClass, withoutMinHeight && style.withoutMinHeight)}>
            {title && (
                <div className={classnames([style.title, style.titleRedesign])}>
                    <FieldTitle
                        title={title}
                        isValid={isValid}
                        theme={boldTitle ? FieldTitleTheme.Bold : FieldTitleTheme.WithoutPadding}
                        modificators={[FieldTitleModificator.InheritColor]}
                    />
                    {isHidingText && (
                        <div
                            className={style.showIcon}
                            onClick={() => setIsHide(!isTextHide)}
                        >
                            <Icon type={isTextHide ? IconType.SHOW : IconType.HIDE} />
                        </div>
                    )}
                </div>
            )}
            {isTextHide ? (
                '*****'
            ) : (
                <div className={classnames([style.text, ...modifiers])}>
                    {prefix && <div className={style.prefix}>{prefix}</div>}
                    {text}
                </div>
            )}
        </div>
    );
}
